export const clinic = [
  "clinic",
  "clinics-registered",
  "clinic-and-professionals",
  "clinics-registered-report"
]

export const doctor = [
  "doctor",
  "doctors-registered",
  "doctors-pending",
  "doctor-report"
]

export const consultant = [
  "consultant",
  "dashboard-consultant",
  "general-requests",
  "general-appointments",
  "general-returns",
  "customers",
  "divers",
  "pharmacy",
  "analytical-consultation-of-schedules",
  "customer-report-attendance",
  "quicksight-attendance-dashboard",
  "laboratory-exams",
  "laboratory-search",
  "managed-match",
  "associate-lab-exam",
  "register-marketplace-categoria",
  "register-specialty",
  "register-exames",
  "register-laboratory",
  "register-medicine",
  "register-parceiros",
  "register-marketplace-produto"
]

export const financial = [
  "financial",
  "dashboard-financial",
  "financial-parameterization-products-and-services",
  "financial-parameterization-messages",
  "account-information-and-balances",
  "transfer-of-values",
  "conciliation-balance",
  "financial-statement-filoo",
  "transaction-report",
  "block-balance",
  "medical-appointments-performed-x-rps",
  "pf-customer-reports",
  "invoice-report",
  "iugu-report",
  "withdraw-report",
  "pool-extract-report",
  "exposure-report",
  "tax-report",
  "professionals-statement",
  "client-statement",
  "inactivated",
  "aas-sales-commission-report"
]

export const commercial = [
  "commercial",
  "pending-subscriptions-report",
  "registered-companies",
  "natural-person-customers",
  "company",
  "companies-in-approval",
  "plans",
  "b2c-plans",
  "all-campaigns",
  "back-office-orizon",
  "back-office-cards",
  "aas-registered-agents",
  "aas-new-agents",
  "aas-coupon-association",
  "customers-commercial-report",
  "inactive-employees-report",
  "quicksight-commercial-dashboard",
  "customers-without-first-access",
  "associate-service-package",
  "register-plan-package",
  "register-plan-service",
  "external-provider",
  "external-provider-token",
  "health-plan-transfer",
  "advertising-message",
  "expired-invoices",
  //// MOCK2REMOVE
  "specialties-management",
  //// MOCK2REMOVE
]

export const technology = [
  "technology",
  "backup",
  "user-register",
  "manage-permissions",
  "systems-list",
  "product-backlog"
]

export const helpdesk = [
  "helpdesk",
  "new"
]

export const indicators = [
  "indicators"
]

export default {
  clinic,
  doctor,
  consultant,
  financial,
  commercial,
  technology,
  helpdesk,
  indicators
}
